import { ethers } from 'ethers';
import { networkToChainId } from '../constants/EIP1193';

let permitTokenContract = '0x777BaEb8bDaD0E95ea94E3a4Bcc6cC2938763725';
let handlerContract = '0x4F517774388e5f8B5Ab4E20B606E0d035514f890';
const WAYPOINT_REDIRECT_URI = "glip-wallet-host://ronin-signin://open";
const clientId = "f1c850b5-c758-4bee-98e8-c7e728d546c1";

let permitAbi = [
    {
        "inputs": [],
        "name": "name",
        "outputs": [
            {
                "internalType": "string",
                "name": "",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "nonces",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
];

async function getPermitSignature(wallet: any, token: any, spender: any, value: any, deadline: any) {
    const [nonce, name, version, chainId] = await Promise.all([
        token.nonces(wallet.address),
        token.name(),
        '1',
        wallet.getChainId(),
    ]);

    try {
        const hashedStruct = ethers.utils._TypedDataEncoder.hash(
            {
                name: name,
                version: version,
                chainId: chainId,
                verifyingContract: token.address,
            },
            {
                Permit: [
                    {
                        name: 'owner',
                        type: 'address',
                    },
                    {
                        name: 'spender',
                        type: 'address',
                    },
                    {
                        name: 'value',
                        type: 'uint256',
                    },
                    {
                        name: 'nonce',
                        type: 'uint256',
                    },
                    {
                        name: 'deadline',
                        type: 'uint256',
                    },
                ],
            },
            {
                owner: wallet.address,
                spender,
                value,
                nonce,
                deadline,
            }
        );

        let signingKey = new ethers.utils.SigningKey(wallet.privateKey);
        let sig = await signingKey.signDigest(hashedStruct);

        return ethers.utils.joinSignature({
            v: sig.v,
            r: sig.r,
            s: sig.s,
        });
    } catch (e) {
        console.log(e);
        return null;
    }
}

async function getWaypointPermitSignature(wallet: any, token: any, spender: any, value: any, deadline: any) {
    const [nonce, name, version, chainId] = await Promise.all([
        token.nonces(wallet.address),
        token.name(),
        '1',
        wallet.getChainId(),
    ]);

    const domain = {
        name: name,
        version: version,
        chainId: chainId,
        verifyingContract: token.address,
    };

    const types = {
        Permit: [
            { name: 'owner', type: 'address' },
            { name: 'spender', type: 'address' },
            { name: 'value', type: 'uint256' },
            { name: 'nonce', type: 'uint256' },
            { name: 'deadline', type: 'uint256' },
        ],
    };

    const message = {
        owner: wallet.address,
        spender,
        value,
        nonce,
        deadline,
    };

    const payload = {
        domain,
        types,
        message,
    };

    const encodedPayload = btoa(JSON.stringify(payload));
    const redirectURL = encodeURIComponent(WAYPOINT_REDIRECT_URI);
    const roninURL = `https://waypoint.roninchain.com/wallet/sign-typed-data?redirect=${redirectURL}&clientId=${clientId}&data=${encodedPayload}&chainId=2020`;

    openDeeplink(`https://glip.gg/openExternal?url=${btoa(roninURL)}`);
    return await waitForWaypointResponse();
}

export async function getGCPermitRonin(amount: any, walletType: string = 'ronin') {
    try {
        let walletInfo: any = JSON.parse((localStorage.getItem('gw-wallet-info') as any));
        let userAddress: string = walletInfo.address;
        let provider = new ethers.providers.JsonRpcProvider("https://api.roninchain.com/rpc");
        let deadline = ethers.constants.MaxUint256;
        let token = new ethers.Contract(permitTokenContract, permitAbi, provider);

        if (walletType === 'RoninWaypoint') {
            return await getWaypointPermitSignature(
                { address: userAddress, getChainId: () => Promise.resolve(2020) },
                token,
                handlerContract,
                ethers.utils.parseEther(amount.toString()),
                deadline
            );
        } else {
            let pk = walletInfo.privateKey;
            const signer = new ethers.Wallet(pk, provider);
            token = token.connect(signer);
            
            return await getPermitSignature(
                signer,
                token,
                handlerContract,
                ethers.utils.parseEther(amount.toString()),
                deadline
            );
        }
    } catch (e) {
        console.log(e);
        return null;
    }
}

function openDeeplink(deeplink: string): void {
    var nativeData: any = {};
    nativeData['key'] = 7;
    nativeData['deeplink'] = deeplink;
    if (!((window as any).javascript_obj)) {
        console.error("Native support not available.");
        return;
    }
    if (Object.keys(((window as any).javascript_obj)).length === 0) {
        console.error("Native support object is empty.");
        return;
    }
    ((window as any).javascript_obj).nativeSupport(JSON.stringify(nativeData));
}

function waitForWaypointResponse(): Promise<string> {
    return new Promise((resolve, reject) => {
        (window as any).callbackNewIntentData = (data: string) => {
            try {
                const url = new URL(data);
                const type = url.searchParams.get("type");
                const signature = url.searchParams.get("data");
                
                if (type === "success" && signature) {
                    resolve(signature);
                } else {
                    reject(new Error("Failed to get signature"));
                }
            } catch (error) {
                reject(error);
            }
        };

        setTimeout(() => {
            reject(new Error("Signature request timeout"));
        }, 300000);
    });
}